export const LIBRARY_SCHOOL_LEVELS = [
  { id: 'all', label: '전체' },
  { id: 'kindergarten', label: '유치원' },
  { id: 'elementary', label: '초등' },
  { id: 'middle', label: '중등' },
  { id: 'high', label: '고등' },
  { id: 'special', label: '특수' },
  { id: 'common', label: '공통' },
];

export const LIBRARY_SUBJECTS = {
  early_childhood: '놀이·생활',
  korean: '국어',
  math: '수학',
  english: '영어',
  science: '과학',
  social: '사회',
  history: '역사',
  korean_history: '한국사',
  ethics: '도덕·윤리',
  music: '음악',
  art: '미술',
  pe: '체육',
  practical_arts: '실과',
  technology_home_economics: '기술·가정',
  information: '정보',
  career: '진로',
  safety: '안전',
  classroom_management: '학급 운영',
  creative_activities: '창체·동아리',
  environment: '환경',
  parent_communication: '학부모 소통',
  teacher_work: '교사 업무',
  special_education: '특수교육',
  other: '기타',
};

const CORE_SUBJECTS = [
  'korean',
  'math',
  'english',
  'science',
  'social',
  'ethics',
  'music',
  'art',
  'pe',
  'career',
  'safety',
  'classroom_management',
  'creative_activities',
  'environment',
];

export const SUBJECTS_BY_SCHOOL_LEVEL = {
  all: [
    ...CORE_SUBJECTS,
    'history',
    'korean_history',
    'practical_arts',
    'technology_home_economics',
    'information',
    'early_childhood',
    'special_education',
    'parent_communication',
    'teacher_work',
    'other',
  ],
  kindergarten: [
    'early_childhood',
    'korean',
    'math',
    'science',
    'music',
    'art',
    'pe',
    'safety',
    'classroom_management',
    'creative_activities',
    'parent_communication',
  ],
  elementary: [
    'korean',
    'math',
    'social',
    'science',
    'english',
    'ethics',
    'music',
    'art',
    'pe',
    'practical_arts',
    'creative_activities',
    'career',
    'safety',
    'classroom_management',
    'environment',
    'parent_communication',
  ],
  middle: [
    'korean',
    'math',
    'english',
    'social',
    'science',
    'history',
    'ethics',
    'technology_home_economics',
    'information',
    'music',
    'art',
    'pe',
    'creative_activities',
    'career',
    'safety',
    'classroom_management',
    'environment',
  ],
  high: [
    'korean',
    'math',
    'english',
    'social',
    'science',
    'korean_history',
    'history',
    'ethics',
    'technology_home_economics',
    'information',
    'music',
    'art',
    'pe',
    'creative_activities',
    'career',
    'safety',
    'classroom_management',
    'environment',
  ],
  special: [
    'special_education',
    'korean',
    'math',
    'career',
    'early_childhood',
    'music',
    'art',
    'pe',
    'safety',
    'classroom_management',
    'creative_activities',
    'parent_communication',
  ],
  common: [
    'classroom_management',
    'safety',
    'career',
    'creative_activities',
    'environment',
    'parent_communication',
    'teacher_work',
    'other',
  ],
};

export const getLibrarySubjectFilters = (schoolLevel = 'all') => [
  { id: 'all', label: '교과·주제 전체' },
  ...(SUBJECTS_BY_SCHOOL_LEVEL[schoolLevel] || SUBJECTS_BY_SCHOOL_LEVEL.all)
    .map((id) => ({ id, label: LIBRARY_SUBJECTS[id] || id })),
];

export const getLibrarySchoolLabel = (schoolLevel) => (
  LIBRARY_SCHOOL_LEVELS.find((item) => item.id === schoolLevel)?.label || '공통'
);

export const getLibrarySubjectLabel = (subject) => (
  LIBRARY_SUBJECTS[subject] || '기타'
);
